import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Modal } from '@atoms';
import { Control, UseFormHandleSubmit, UseFormSetValue } from 'react-hook-form';
import Form, { FormData } from './CreateEnterPriseAccountForm';

interface MainModalProps {
  open: boolean;
  isConfirmOpen: boolean;
  isSuccessOpen: boolean;
  isDirty: boolean;
  isValid: boolean;
  isLoading: boolean;
  control: Control<FormData, any>;
  values: FormData;
  setValue: UseFormSetValue<FormData>;
  handleSubmit: UseFormHandleSubmit<FormData>;
  onClose: () => void;
  onOpenConfirm: () => void;
  onFinalSubmit: (data: FormData) => Promise<void>;
}

const MainModal: React.FC<MainModalProps> = ({
  open,
  isConfirmOpen,
  isSuccessOpen,
  isDirty,
  isValid,
  isLoading,
  control,
  values,
  setValue,
  handleSubmit,
  onClose,
  onOpenConfirm,
  onFinalSubmit,
}) => {
  return (
    <Modal
      title="Add new account"
      open={open && !isConfirmOpen && !isSuccessOpen}
      onClose={isDirty ? onOpenConfirm : onClose}
    >
      <Box
        component="form"
        display="flex"
        flexDirection="column"
        onSubmit={handleSubmit(onFinalSubmit)}
      >
        <Typography variant="body2" mt="8px" color="text.secondary" mb="40px">
          Here you can invite new Enterprise.
        </Typography>

        <Form values={values} control={control} setValue={setValue} />

        <Box display="flex" justifyContent="flex-end">
          <Button color="secondary" onClick={isDirty ? onOpenConfirm : onClose}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            type="submit"
            disabled={!isValid || !isDirty}
            loading={isLoading}
          >
            Create
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default MainModal;
